import './style.scss';
import $ from 'jquery';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

if($(".wp-block-thanxblocks-post-carousel").length > 0) {
$('.wp-block-thanxblocks-post-carousel').each(function() {
  var self = $(this);
  var $carousel = self.flickity({
    pageDots: false,
    cellAlign: 'left',
    prevNextButtons: false,
    contain: true,
    imagesLoaded: true,
    percentPosition: true,
    wrapAround: true,
    autoPlay: 4000
  });
});
}